import React, { useState } from "react";
import "./style.css";
import emailjs from "emailjs-com";
import Chat from "../../Assets/Home/chat.png";
import logo from "../../Assets/Home/mini.png";

type Message = {
  from: "bot" | "user";
  text: string;
  options?: string[];
};

const ChatBot = () => {
  const [messages, setMessages] = useState<Message[]>([
    { from: "bot", text: "Hi! How can I help you today?" },
  ]);
  const [step, setStep] = useState(1);
  const [input, setInput] = useState("");
  const [userData, setUserData] = useState<any>({});
  const [isOpen, setIsOpen] = useState(false);

  const sendToEmailJS = (data: any) => {
    // console.log("Data received in sendToEmailJS:", data);
    // console.log("Description value:", data.description); // Add this
  
    const templateParams = {
      name: data.name || "",
      email: data.email || "",
      phone: data.phone || "",
      purpose: data.purpose || "",
      description: data.description || "", // Will be empty if data.description is undefined
    };
  
    emailjs
      .send(
        "service_bc9fvv6",
        "template_wkv9jv8",
        templateParams,
        "ySvODPYuKvw7Y_GBT"
      )
      .then(
        (response) => {
          // console.log("Email sent successfully!", response.status, response.text);
          // console.log("Sending email with:", templateParams);
        },
        (error) => {
          // console.error("Email sending failed:", error);
        }
      );
  };
  

  const handleOptionClick = (option: string) => {
    const userMessage = { from: "user", text: option } as const;
    const botMessage: Message = {
      from: "bot",
      text: "Please describe briefly what you need.",
    };

    setUserData((prev) => ({ ...prev, purpose: option }));
    setMessages([...messages, userMessage, botMessage]);
    setStep(5);
  };

  const handleSend = () => {
    if (!input.trim()) return;

    const userMessage = { from: "user", text: input } as const;
    let botMessage: Message = { from: "bot", text: "" };
    let nextStep = step;

    if (step === 1) {
      setUserData((prev) => ({ ...prev, name: input }));
      botMessage = {
        from: "bot",
        text: "Nice to meet you! Can I get your email?",
      };
      nextStep = 2;
    } else if (step === 2) {
      setUserData((prev) => ({ ...prev, email: input }));
      botMessage = {
        from: "bot",
        text: "Thanks! What’s your phone number?",
      };
      nextStep = 3;
    } else if (step === 3) {
      setUserData((prev) => ({ ...prev, phone: input }));
      botMessage = {
        from: "bot",
        text: "What are you looking for?",
        options: ["Sales", "Services", "Career", "Support", "Other"],
      };
      nextStep = 4;
    } else if (step === 4) {
      setUserData((prev) => ({ ...prev, purpose: input }));
      botMessage = {
        from: "bot",
        text: "Please describe briefly what you need.",
      };
      nextStep = 5;
    } else if (step === 5) {
      const updatedUserData = { ...userData, description: input };
      setUserData(updatedUserData);
      sendToEmailJS(updatedUserData); 
      botMessage = {
        from: "bot",
        text: "Thank you! We’ll be in touch soon.",
      };
      nextStep = 6;
    } else {
      botMessage = {
        from: "bot",
        text: "Thanks again! If you need anything else, just type it here.",
      };
    }

    setMessages([...messages, userMessage, botMessage]);
    setInput("");
    setStep(nextStep);
  };

  return (
    <>
      {!isOpen && (
        <div className="chat-toggle" onClick={() => setIsOpen(true)}>
          <img src={Chat} alt="chat" />
        </div>
      )}

      {isOpen && (
        <div className="chat-container">
          <div className="chat-header">
            <span className="chat-header-txt">We're here to help!</span>
            <div className="close-btn" onClick={() => setIsOpen(false)}>
              ✖
            </div>
          </div>

          <div className="chat-box">
            {messages.map((msg, i) => (
              <div key={i} className={`message ${msg.from}`}>
                <div className="message-avatar">
                  {msg.from === "bot" && (
                    <img src={logo} alt="Bot Logo" className="mini-logo" />
                  )}
                </div>
                <div>
                  <p>
                    <strong>{msg.from === "bot" ? "" : "You"} </strong> {msg.text}
                  </p>
                  {msg.options && (
                    <div className="options-container">
                      {msg.options.map((opt, idx) => (
                        <div
                          key={idx}
                          className="option-button"
                          onClick={() => handleOptionClick(opt)}
                        >
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="input-area">
            <input
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Type your message..."
            />
            <div className="chat-send" onClick={handleSend}>
              Send
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatBot;
